var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1051,
    height: 645.104,
    viewBox: "0 0 1051 645.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#a);}.b,.k,.l,.p{fill:#fff;}.c,.g{fill:#f4f1de;}.c,.d,.e,.g,.h{stroke:#e17a5f;}.c,.d,.e,.f,.g,.h,.i,.r{stroke-miterlimit:10;}.d,.h{fill:#f2cc8e;}.e,.r,.t{fill:none;}.e,.f,.g,.h{stroke-linecap:round;stroke-linejoin:round;}.f{fill:#e17a5f;}.f,.i,.n,.t{stroke:#fff;}.i,.j,.n,.s{fill:#3d3f5b;}.j,.k,.l,.o,.q{font-size:17px;}.j,.k,.o{font-family:MyriadPro-Bold, Myriad Pro;font-weight:700;}.l,.p,.q{font-family:MyriadPro-Regular, Myriad Pro;}.m,.o,.q{fill:#e07a5f;}.p{font-size:9px;}.r{stroke:#3d3f5b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388.581,
    height: 629.439
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.48 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M519.9,135.713s-46.495-2.941-39.052,50.109H480.8c-4.423,0-7.981,7.139-7.981,15.951,0,8.789,3.558,15.928,7.981,15.928a3.43,3.43,0,0,0,1.381-.258c1.886,11.73,6.062,24.269,14.929,32.149l-.236,6.23a22.442,22.442,0,0,1-11.753,18.825l-13.279,7.184a62.718,62.718,0,0,1-23.214,7.308c-17.365,1.8-51.535,13.538-48.695,78.879l-9.1,80.484s-15.188,49.346-9.867,84.256c5.3,34.944,4.535,63.77,0,79.721-3.222,11.225-5.68,29.23-6.859,38.906a16.779,16.779,0,0,0,3.154,11.944l16,21.687a4.3,4.3,0,0,0,7.027-.168,4.144,4.144,0,0,0,.718-2.369,3.97,3.97,0,0,0-.236-1.381l-9.216-20.733a18.946,18.946,0,0,1,.505-16.58l5.613-10.821s6.062,21.26,12.134,21.26c6.1,0,.763-28.085.763-28.085s-.763-18.959-6.825-25.818c0,0,21.26-74.389,25.055-97.154a159.393,159.393,0,0,0,2.144-23.382,235.268,235.268,0,0,1,5.512-45.428l10.035-38.1a2.016,2.016,0,0,1,3.918.067c2.728,12.516,7.352,38.042,5.736,62.019-2.29,33.417-6.769,57.226-15.951,81.988-18.005,48.526-11.394,171.576-4.557,218.643s-6.062,113.868.763,141.953c6.836,28.108,13.661,97.939,13.661,97.939s-3.794,24.291-3.031,33.417c.763,9.1-22.024,30.353-11.394,36.448,10.63,6.062,48.6,7.6,48.6,3.031s-4.557-18.982-6.1-28.849c-1.5-9.867,5.321-20.486,1.527-31.116s-3.031-14.424-2.267-27.344c.741-12.9,22.765-73.626,18.959-98.68s-9.867-67.564-8.34-78.194c1.5-10.63,29.589-150.316,29.589-165.5l2.324-18.465,2.324,18.465c0,15.188,28.085,154.873,29.589,165.5,1.527,10.63-4.535,53.14-8.34,78.194s18.218,85.783,18.959,98.68c.763,12.92,1.527,16.714-2.268,27.344s3.031,21.26,1.527,31.116c-1.527,9.867-6.1,24.291-6.1,28.849s37.975,3.031,48.6-3.031c10.63-6.1-12.157-27.344-11.394-36.448.763-9.126-3.031-33.417-3.031-33.417s6.825-69.832,13.661-97.939c6.825-28.085-6.062-94.886.763-141.953s17.208-182.97-4.557-218.643c-13.762-22.54-13.661-48.582-15.951-81.988-1.628-23.977,3.008-49.514,5.736-62.019a2.016,2.016,0,0,1,3.918-.067l10.035,38.1a233.532,233.532,0,0,1,5.512,45.428,162.545,162.545,0,0,0,2.144,23.382c3.794,22.765,25.055,97.154,25.055,97.154-6.062,6.859-6.825,25.818-6.825,25.818s-5.321,28.085.763,28.085c6.062,0,12.134-21.26,12.134-21.26l5.613,10.821a19.02,19.02,0,0,1,.505,16.58L639.095,681.1a3.97,3.97,0,0,0-.236,1.381,4.17,4.17,0,0,0,.718,2.369,4.3,4.3,0,0,0,7.027.168l16-21.687a16.765,16.765,0,0,0,3.154-11.944c-1.167-9.676-3.626-27.681-6.859-38.906-4.535-15.951-5.3-44.777,0-79.721,5.321-34.921-9.867-84.256-9.867-84.256l-9.1-80.484c2.84-65.342-31.329-77.094-48.695-78.879a62.652,62.652,0,0,1-23.214-7.308l-13.279-7.184a22.427,22.427,0,0,1-11.753-18.825l-.236-6.23c8.857-7.88,13.044-20.419,14.929-32.149a3.466,3.466,0,0,0,1.381.258c4.423,0,7.981-7.139,7.981-15.928,0-8.812-3.558-15.951-7.981-15.951h-.045c7.453-53.039-39.052-50.109-39.052-50.109H519.9Z",
    transform: "translate(-330.044 -101.398)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.663 45.484)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M490.76,189.993a14.647,14.647,0,0,0,15.165,8.924s10.35,3.57,17.837-7.5l1.426-8.565L507.7,177.14l-10.709,1.785Z",
    transform: "translate(-472.4 -141.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M508.816,145.671v39.6a92.858,92.858,0,0,1-8.565,5.354c-3.21,1.605.539,4.277-7.5,3.21s-11.236,2.144-12.842-2.144-6.421-3.21-5.354-10.709,2.672-9.631,2.144-13.38-1.066-8.565,3.21-10.709,3.21-3.749,9.1-6.96,13.919-4.277,13.919-4.277h5.882Z",
    transform: "translate(-474.404 -145.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M505.88,145.671v39.6a92.862,92.862,0,0,0,8.565,5.354c3.21,1.605-.539,4.277,7.5,3.21s11.236,2.144,12.842-2.144,6.421-3.21,5.354-10.709-2.672-9.631-2.144-13.38,1.066-8.565-3.21-10.709-3.21-3.749-9.1-6.96-13.919-4.277-13.919-4.277H505.88Z",
    transform: "translate(-470.548 -145.66)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.374 3.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M499.075,149.24c-.022.775-.045,1.56-.067,2.335a7.727,7.727,0,0,0,.337,3.132,2.7,2.7,0,0,0,2.368,1.818c-.775.528-1.863-.045-2.75.236-1.179.382-1.392,1.92-1.4,3.154-.011,1.8.1,3.861,1.515,4.973.494.393,1.19.741,1.212,1.369.022.539-.471.943-.842,1.336a3.886,3.886,0,0,0,.269,5.377c.37.326.864.718.73,1.2a1.248,1.248,0,0,1-.393.516,5.284,5.284,0,0,0-.853,6.264",
    transform: "translate(-474.941 -149.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M496.209,152.212a6.661,6.661,0,0,0-3.637.2,2.96,2.96,0,0,0-1.931,2.851,25.964,25.964,0,0,0-2.941-3.435",
    transform: "translate(-476.149 -148.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M483.78,154.8l6.589,6.522",
    transform: "translate(-476.63 -148.385)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M496.919,163.816a12.977,12.977,0,0,0-5.164.572,3.936,3.936,0,0,0-1.762,1c-.887.988-.775,2.548-1.459,3.682-.46.752-1.246,1.268-1.774,1.976s-.707,1.863.011,2.391",
    transform: "translate(-476.321 -147.287)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M487.027,161.8c-2.638,1.83-5.444,3.884-6.365,6.96a8.572,8.572,0,0,1-.64,1.92,1.6,1.6,0,0,1-1.673.864",
    transform: "translate(-477.295 -147.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M482.921,164.4a34.536,34.536,0,0,1-2.571-3.289",
    transform: "translate(-477.05 -147.612)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M477.41,174.99a15.241,15.241,0,0,1,5.265,3.177,8.523,8.523,0,0,1,1.919,2.47,5.805,5.805,0,0,1,.539,2.818",
    transform: "translate(-477.41 -145.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M480.73,182.67c2.425.617,4.849,1.224,7.274,1.841a13.781,13.781,0,0,1,3.48,1.224,4.556,4.556,0,0,1,2.279,2.8",
    transform: "translate(-477.003 -144.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M487.22,177.34a106.474,106.474,0,0,0,8.868,7.5,5.589,5.589,0,0,0,2.088,1.134c.786.168,2.189.146,2.582-.55",
    transform: "translate(-476.208 -145.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M521.283,149.113a3.331,3.331,0,0,0-3.581,2.47,5.165,5.165,0,0,1-.572,2.211,2.373,2.373,0,0,1-2.582.415,9.52,9.52,0,0,0-2.649-.819,10.539,10.539,0,0,1,1.313,3.064,2.19,2.19,0,0,1-1.56,2.571c1.774.393,2.369,3.02,1.145,4.367a2.162,2.162,0,0,0-.55.73c-.3,1,1.426,1.628,1.381,2.672-.034.741-.9,1.1-1.628,1.224s-1.594.247-1.919.909a3.768,3.768,0,0,1,2.054,6.522",
    transform: "translate(-473.408 -149.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M515.6,164.346a3.059,3.059,0,0,1,3-.752,28.638,28.638,0,0,0,3.154.763,1.276,1.276,0,0,0,1.066-.292,1.323,1.323,0,0,0,.258-.707A6.011,6.011,0,0,0,518.923,157c-.92-.269-2.11-.494-2.324-1.437.269-.112.55-.224.819-.348",
    transform: "translate(-472.731 -148.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M520.51,152.19q2.475,2.206,4.939,4.411a2.657,2.657,0,0,1,.808,1,8.393,8.393,0,0,1,.168,1.414,2.779,2.779,0,0,0,1.908,2.009,8.231,8.231,0,0,0,2.874.3",
    transform: "translate(-472.13 -148.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M532.156,164.347a2.01,2.01,0,0,0-2.11.382,3.617,3.617,0,0,0-1.066,1.953,4.824,4.824,0,0,1-.516,1.639,2.5,2.5,0,0,1-3.289.427,10.608,10.608,0,0,1-2.548-2.6,1.293,1.293,0,0,0-.55-.438,1.127,1.127,0,0,0-.662.067,6.291,6.291,0,0,0-3.311,2.133,3.5,3.5,0,0,0-.348,3.772,7.945,7.945,0,0,0,1.74,1.729,2.985,2.985,0,0,1,1.2,2.065c.011.819-.831,1.65-1.594,1.336",
    transform: "translate(-472.517 -147.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M519.82,170.447c.8.225,1.021.483,1.818.718.168-.707.55-1.515.079-2.065a4.2,4.2,0,0,0,1.021,4.052,12.551,12.551,0,0,0,3.547,2.537",
    transform: "translate(-472.214 -146.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M530.02,174.75c-.449,1.2-.909,2.413-1.358,3.615a6.449,6.449,0,0,1-.8,1.628,4.681,4.681,0,0,1-2.2,1.448,28.561,28.561,0,0,1-6.488,1.033c-2.178.258-4.456.819-6.017,2.368",
    transform: "translate(-473.03 -145.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M514.73,182.66c0-1.426.393-2.425.393-3.85",
    transform: "translate(-472.838 -145.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M525.983,185.751a10.708,10.708,0,0,0-8.183,3.311",
    transform: "translate(-472.462 -144.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M534.721,176.9c-.831,1.74-5.949,2.335-6.365,4.221a2.786,2.786,0,0,0,.034,1.055c.146.92.281,1.83.427,2.75a3.784,3.784,0,0,1-.034,1.908,1.316,1.316,0,0,1-1.493.909",
    transform: "translate(-471.299 -145.677)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M527.68,226.26l-13.56,12.134s10.776.92,12.527-4.176S527.68,226.26,527.68,226.26Z",
    transform: "translate(-312.876 -90.301)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M470.742,446.281s-4.636,8.206,2.5,21.406,17.13,28.546,13.919,36.044-7.846,16.052-17.13,10.35-22.832-18.555-21.047-38.9c1.078-12.314,2.818-25.548,4.019-34.068a13.864,13.864,0,0,1,15.075-11.955,50.387,50.387,0,0,1,14.088,3.929c19.734,8.307,45.17,13.93,71.751-13.751a8.6,8.6,0,0,1,6.185-2.66h0a8.563,8.563,0,0,1,8.554,8.767c-.438,17.276-1.47,54.476-2.279,59.392-1.066,6.421-20.34,44.957-30.69,46.382a15.781,15.781,0,0,1-15.345-6.78l-.718,20.34-14.278-1.426s-3.929-35.685,3.57-39.962a13.186,13.186,0,0,1,17.13,3.57c2.5,3.57,5.714,11.416,5.714,11.416s.359-2.5,6.421-9.272,14.986-23.191,14.986-23.191l-1.426-42.824s-11.775,14.626-38.9,15.345C485.727,459.122,470.742,446.281,470.742,446.281Z",
    transform: "translate(-320.875 -66.972)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M514.894,530.829s-14.626-1.785-23.191,1.785-3.929,20.7,11.775,23.191l1.785,7.5h3.57l-.359-6.062s14.885-4.569,18.2-17.837C528.1,533.691,514.894,530.829,514.894,530.829Z",
    transform: "translate(-316.142 -53.042)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.132 226.939)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M512.824,322.425a36.077,36.077,0,0,1-.932,5.624c-.8,3.345-3.615,6.151-2.009,10.439s.539,10.439.539,10.439,2.941,8.834,11.236,9.238,3.614,6.286,10.709,5.624a46.19,46.19,0,0,0,10.967-2.144s.808,4.019,5.22,2.672,8.565-11.1-2.279-32.912c0,0,1.066-6.151-8.026-10.17s-20.879-5.085-20.879-5.085Z",
    transform: "translate(-503.586 -306.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M533.693,315.168s-2.144-1.426-2.5-2.851a22.227,22.227,0,0,1-.359-4.064l-2.009-.135-.269,2.672-1.471-.135-1.066-3.345-2.144.808-.269,2.806-1.066-.269-1.471-2.672-2.941,1.47,2.279,3.21s-2.806,1.875-2.941,2.806a27.914,27.914,0,0,0,1.336,7.5c.808,2.279,1.852.112,3.884,3.21,1.717,2.615.853,4.041,1.134,4.12l4.12-.617,5.321-5.916Z",
    transform: "translate(-502.6 -307.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M540.634,314.31s2.851,2.851,1.785,5-9.99-.718-7.5,8.924c0,0-3.21,4.277-9.99-.359,0,0,0-1.785,2.851-2.851s-6.78-9.631,2.5-9.99S540.634,314.31,540.634,314.31Z",
    transform: "translate(-501.683 -306.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M519.082,314.664s-1.605-.808-5.759-.4a28.281,28.281,0,0,1-7.5-.269l-1.605,4.277s5.242,3.076,5.624,2.941C519.778,317.851,519.082,314.664,519.082,314.664Z",
    transform: "translate(-504.22 -306.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M509.253,321.131c-.92.314,3.614,1.47,3.614,1.47s5.759-1.47,5.759-4.681v-3.21S516.336,318.762,509.253,321.131Z",
    transform: "translate(-503.618 -306.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M524.738,327.73c-.775,2.705-2.941,4.8-5.321,6.331s-5.006,2.6-7.386,4.108a3.207,3.207,0,0,0-1.751,2.155c-.011.135.09.326.2.258",
    transform: "translate(-503.478 -304.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M519.657,322.02a4.2,4.2,0,0,1-2.155,2.773c-1.605,1.111-3.659,1.268-5.6,1.392.112.079.225.146.337.225",
    transform: "translate(-503.279 -305.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M520.47,331.84c2.054,1.1,3.446,3.334,6.039,2.559.741-.225,1.515-.662,2.245-.393a2.557,2.557,0,0,1,1.156,1.224",
    transform: "translate(-502.229 -304.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M523.994,334.28a5.034,5.034,0,0,0,.494,4.052c.168.281.46.572.763.471",
    transform: "translate(-501.824 -304.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M520.2,332.6c.438,2.054-.415,4.165-.449,6.264a8.214,8.214,0,0,0,.629,3.233",
    transform: "translate(-502.317 -304.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M517.245,334.39a4.1,4.1,0,0,1-.056,5.2c-.752.965-1.931,1.639-2.368,2.784",
    transform: "translate(-502.921 -303.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M513.1,336.52c.37,2.357-.9,4.759-.471,7.105.382,2.077,2.009,3.671,3.581,5.1a11.962,11.962,0,0,0,3.906,2.66,20.49,20.49,0,0,1,2.986.932c1.347.707,2.144,2.088,3.053,3.311s2.166,2.4,3.682,2.346",
    transform: "translate(-503.201 -303.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M522.94,350.969a8,8,0,0,1,5.175.64c1.179.584,2.346,1.482,3.659,1.313",
    transform: "translate(-501.927 -301.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M521.58,350.082a5.759,5.759,0,0,1,5.927-2.144",
    transform: "translate(-502.093 -302.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M522.75,351.174c1.56-.438,6.634-1.919,8.239-1.762",
    transform: "translate(-501.95 -302.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M533.59,327.05a22.794,22.794,0,0,1,4.254,3.02,7.607,7.607,0,0,1,2.4,4.524c.191,1.875-.561,3.783-.146,5.613.382,1.684,1.706,3.087,1.875,4.816.2,2.122-1.414,4.165-1.01,6.252a11.219,11.219,0,0,0,1.751,3.289c.617,1.089.932,2.582.09,3.5-.64.7-3,1.033-2.638,1.908",
    transform: "translate(-500.622 -304.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M538.8,336.26c-2,.011-3.356,1.111-3.278,3.267a11.19,11.19,0,0,1,.09,3.345",
    transform: "translate(-500.386 -303.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M535.8,338.211a3.034,3.034,0,0,0-3.1,2.514",
    transform: "translate(-500.731 -303.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M540.318,341.01a5.752,5.752,0,0,1-3.188.718",
    transform: "translate(-500.188 -303.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M534.12,327.33c.662-1.033,1.976-.831,3.2-.775a7.373,7.373,0,0,1,5.691,3.21",
    transform: "translate(-500.557 -304.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M539.53,333.11c2.122.2,3.693,2.391,3.974,4.5",
    transform: "translate(-499.894 -304.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M546.677,338.61c.056,1.538-.415,3.985-1.572,5.006a13.386,13.386,0,0,1-1.8,1.123,5.945,5.945,0,0,0-2.47,3.267c1.9.269,4.367,1.055,4.726,2.941.112.584.056,1.19.146,1.774a3.682,3.682,0,0,0,2.155,2.8",
    transform: "translate(-499.734 -303.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M543.83,347.933a2.833,2.833,0,0,1,2.672.292",
    transform: "translate(-499.367 -302.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M540.818,346.967a14.593,14.593,0,0,0-4.636.056,4.2,4.2,0,0,0-2.952,2.29",
    transform: "translate(-500.666 -302.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M540.6,349.363a2.893,2.893,0,0,0-3.064.281,13.431,13.431,0,0,1-1.706,2.166",
    transform: "translate(-500.347 -302.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M541.956,342.73a4.908,4.908,0,0,1-1.426,2.11,3.826,3.826,0,0,1-1.336.528,17.317,17.317,0,0,1-4.984.46,3.2,3.2,0,0,0-1.179.067.992.992,0,0,0-.752.819",
    transform: "translate(-500.782 -302.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M541.269,350.71c-.326,1.134-1.369,2.885-2.492,3.233a6.828,6.828,0,0,0-1.718.55",
    transform: "translate(-500.197 -301.993)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.164 376.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M603.316,441.168s-3.21-1.426-4.636,2.5c0,0,14.278,24.976,16.77,45.675,0,0,3.929,3.929,4.636-1.426S607.952,445.455,603.316,441.168Z",
    transform: "translate(-598.68 -440.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M618.256,482.866s-2.5-2.5-4.636,1.426",
    transform: "translate(-596.85 -435.872)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 51.389)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 230.014,
    height: 135.398,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 230.014,
    height: 32.115,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "j",
    transform: "translate(11.772 21.375)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Clinical")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.772 39.545)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Olfactory impairment ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg, "), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    y: 0
  }, "UPSIT"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ")")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 61.717)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RBD ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 83.269)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg, "), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    y: 0
  }, "polysomnography"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ")")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 503.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M0,0H230.014V141.482H0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 230.014,
    height: 32.115,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "j",
    transform: "translate(11.771 22.453)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pathological")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.771 40.623)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Colonic biopsy ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(ie, \u03B1")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(35.718 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-synuclein staining")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(176.021 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ")")), /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 61.717)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Skin biopsy ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 83.269)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(ie, \u03B1-synuclein staining)")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 214.097)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 230.014,
    height: 261.456,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 230.014,
    height: 32.115
  }), /*#__PURE__*/React.createElement("text", {
    className: "j",
    transform: "translate(11.772 22.449)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Imaging"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.772 40.619)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PET")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg,")), /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(31.663 28.184)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(42.406 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F-dopa,")), /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(103.056 28.184)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(113.799 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C-DTBZ)")), /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 61.717)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SPECT")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 83.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg,")), /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(31.663 76.901)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "123")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(47.777 83.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I-CIT)")), /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 110.434)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Specialised MRI")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 131.987)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg, DTI)")), /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 159.152)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Transcranial sonography")), /*#__PURE__*/React.createElement("text", {
    className: "o",
    transform: "translate(0 180.704)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cardiac imaging")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 202.256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg,")), /*#__PURE__*/React.createElement("text", {
    className: "p",
    transform: "translate(31.663 195.888)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "123")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(47.777 202.256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I-MIBG scintigraphy)")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(819.986 51.389)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 230.014,
    height: 306.132,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 230.014,
    height: 32.115,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "j",
    transform: "translate(11.77 21.375)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Biochemical")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.77 39.545)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CSF ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg, ")), /*#__PURE__*/React.createElement("text", {
    className: "q",
    transform: "translate(31.666 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u03B1-synuclein"), /*#__PURE__*/React.createElement("tspan", {
    className: "b",
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    xmlSpace: "preserve"
  }, " DJ-1"), /*#__PURE__*/React.createElement("tspan", {
    className: "b",
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    xmlSpace: "preserve"
  }, " tau"), /*#__PURE__*/React.createElement("tspan", {
    className: "b",
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "q",
    transform: "translate(0 56.105)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xDF-amyloid"), /*#__PURE__*/React.createElement("tspan", {
    className: "b",
    y: 0
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    className: "q",
    transform: "translate(0 77.657)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xDF-glucocerebrosidase"), /*#__PURE__*/React.createElement("tspan", {
    className: "b",
    y: 0
  }, ")")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 104.822)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Saliva ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 126.374)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(no known biomarkers)")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 153.539)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Urine ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 175.091)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(no known biomarkers)")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 202.256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Serum/plasma ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 223.808)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg, "), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    y: 0
  }, "uric acid"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    y: 0
  }, "glutathione"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ", ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 245.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "other low MW molecules)")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(817.842 421.774)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 230.014,
    height: 161.44,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 230.014,
    height: 32.115,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "j",
    transform: "translate(11.773 22.445)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Genetic")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.773 40.615)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Specific gene testing ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 34.552)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(eg, "), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    y: 0
  }, "gene sequencing"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "m",
    y: 0
  }, "MLPA"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, ")")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 61.717)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Next-generation ")), /*#__PURE__*/React.createElement("text", {
    className: "k",
    transform: "translate(0 83.269)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sequencing ")), /*#__PURE__*/React.createElement("text", {
    className: "l",
    transform: "translate(0 104.822)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(no known biomarkers)")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.361 76.769)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M241.14,420.622h42.016v-243H517.447",
    transform: "translate(-237.133 -173.029)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 243.372)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M241.791,398.781a4.221,4.221,0,1,1,4.221-4.221A4.216,4.216,0,0,1,241.791,398.781Z",
    transform: "translate(-237.57 -390.34)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(275.824)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M484.065,182.712l-.775-.819,4.063-3.772-4.063-3.772.775-.819,4.928,4.591Z",
    transform: "translate(-483.29 -173.53)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.36 265.172)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M242.09,495.327h66.644V345.46H528.039",
    transform: "translate(-238.083 -340.869)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 150.237)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M242.741,483.651a4.221,4.221,0,1,1,4.221-4.221A4.216,4.216,0,0,1,242.741,483.651Z",
    transform: "translate(-238.52 -475.21)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.467 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M493.593,350.552l-.763-.819,4.052-3.772-4.052-3.772.763-.819,4.939,4.591Z",
    transform: "translate(-492.83 -341.37)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.361 451.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M241.14,608.591h184.4v-97.2h52.309",
    transform: "translate(-237.133 -506.799)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 97.571)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M241.791,568.521a4.221,4.221,0,1,1,4.221-4.221A4.216,4.216,0,0,1,241.791,568.521Z",
    transform: "translate(-237.57 -560.08)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.222 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M448.773,516.482l-.763-.819,4.052-3.772-4.052-3.76.763-.831,4.939,4.591Z",
    transform: "translate(-448.01 -507.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.36 600.871)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "r",
    x2: 220.641,
    y2: 1.044,
    transform: "translate(4.007 4.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M244.628,602.871a4.221,4.221,0,1,1,4.243-4.2A4.216,4.216,0,0,1,244.628,602.871Z",
    transform: "translate(-240.43 -594.43)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.148 0.662)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M437.313,604.2l-.763-.831,4.075-3.749-4.041-3.783.775-.819,4.917,4.614Z",
    transform: "translate(-436.55 -595.02)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(567.993 60.717)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M783.359,195.569H748.831V163.32H538.09",
    transform: "translate(-536.878 -158.729)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.048 32.62)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M756.861,201.52a4.221,4.221,0,1,1-4.221,4.221A4.216,4.216,0,0,1,756.861,201.52Z",
    transform: "translate(-752.64 -201.52)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M541.949,159.23l.763.819-4.052,3.76,4.052,3.772-.763.819-4.939-4.591Z",
    transform: "translate(-537.01 -159.23)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.135 139.921)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M782.383,281.126H720.027V233.88H528.56",
    transform: "translate(-527.336 -229.289)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.613 47.616)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M754.951,253.97a4.221,4.221,0,1,1-4.221,4.221A4.216,4.216,0,0,1,754.951,253.97Z",
    transform: "translate(-750.73 -253.97)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M532.409,229.79l.763.831-4.052,3.76,4.052,3.772-.763.819-4.939-4.591Z",
    transform: "translate(-527.47 -229.79)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(546.665 235.39)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M784.746,294.92H599.273V539.169h-81.2",
    transform: "translate(-516.846 -290.699)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.465 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "s",
    cx: 4.221,
    cy: 4.221,
    r: 4.221
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 243.879)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M521.919,532.1l.763.819-4.052,3.772,4.052,3.76-.763.831-4.939-4.591Z",
    transform: "translate(-516.98 -532.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(669.019 283.397)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M769.516,329.25h-93.4V444.132H624.88",
    transform: "translate(-623.656 -325.029)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.426 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "s",
    cx: 4.221,
    cy: 4.221,
    r: 4.221
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 114.512)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M628.729,459.62l.763.819-4.052,3.772,4.052,3.772-.763.819-4.939-4.591Z",
    transform: "translate(-623.79 -459.62)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(657.794 438.589)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M771.635,570.6H737.8V499.95H616.29",
    transform: "translate(-615.078 -495.359)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.123 71.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M754.951,559.13a4.221,4.221,0,1,1-4.221,4.221A4.216,4.216,0,0,1,754.951,559.13Z",
    transform: "translate(-750.73 -559.13)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M620.149,495.86l.763.819-4.052,3.772,4.052,3.772-.763.819-4.939-4.591Z",
    transform: "translate(-615.21 -495.86)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M-7377.287,6025.568h417.447",
    transform: "translate(7694.061 -5395.2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanBody2);
export default __webpack_public_path__ + "static/media/human-body-2.9b129f217e3e9ba4c6ebb14f44786449.svg";
export { ForwardRef as ReactComponent };